import type { CaseStudyContent } from './caseDetails';

export const bankGeoCase = {
  "eyebrow": "银行金融行业 GEO 案例",
  "summary": "一家匿名银行针对六类金融产品开展 GEO 项目，监测国内 6 个 AI 平台上的 50 个全国性主要问题。2025 年 11 月至 2026 年 8 月分三阶段推进，出现回答率依次为 60%、85%、80%；项目已于 2026 年 8 月底交由银行内部运营。",
  "duration": "2025 年 11 月—2026 年 8 月",
  "keywords": [
    "银行GEO",
    "金融服务",
    "AI回答监测",
    "贷款产品信息",
    "知识库审核"
  ],
  "metrics": [
    {
      "value": "6 个",
      "label": "AI 观察平台",
      "note": "国内平台，区别于监测工具"
    },
    {
      "value": "50 个",
      "label": "全国性主要问题",
      "note": "覆盖产品类目、品牌和产品问题"
    },
    {
      "value": "80%",
      "label": "第 3 阶段出现回答率",
      "note": "项目方口径，不是贷款转化率"
    },
    {
      "value": "200 条",
      "label": "第 3 阶段知识条目",
      "note": "条目数不等于问题数"
    }
  ],
  "overview": [
    {
      "label": "案例主体",
      "value": "匿名银行，机构及产品数据经过脱敏"
    },
    {
      "label": "六类需求",
      "value": "车贷、车抵贷、房抵贷、消费贷、经营贷、信用卡分期"
    },
    {
      "label": "监测范围",
      "value": "6 个国内 AI 平台、50 个全国性主要问题"
    },
    {
      "label": "实施周期",
      "value": "三个不等长阶段：2025.11—2026.01、2026.02—05、2026.06—08"
    },
    {
      "label": "监测工具",
      "value": "体系致胜 GEO 监控 Agent 与透镜 GEO 对照记录"
    },
    {
      "label": "交付状态",
      "value": "2026 年 8 月底交付银行，后续由内部运营"
    }
  ],
  "channelsTitle": "信息基础：统一三类信源的产品事实",
  "channelsDescription": "按原案例披露的信源类型整理，不使用通用广告流量指标。",
  "channelHeaders": [
    "信源",
    "整理对象",
    "核对重点"
  ],
  "channels": [
    {
      "channel": "银行官网",
      "traffic": "产品信息与办理说明",
      "challenge": "事实、适用条件与费用表述"
    },
    {
      "channel": "银行自媒体",
      "traffic": "产品介绍与需求解答",
      "challenge": "与官方信息保持一致"
    },
    {
      "channel": "新闻媒体稿件",
      "traffic": "经过审核的相关内容",
      "challenge": "核实依据，不编造榜单或同业比较"
    }
  ],
  "painPointsTitle": "信息整理与效果判断的四个重点",
  "painPoints": [
    {
      "title": "多来源信息需要一致",
      "description": "不同渠道的产品描述需回到银行资料核对。"
    },
    {
      "title": "用户问法不能变成承诺",
      "description": "利率、额度与审批描述应保留真实适用条件。"
    },
    {
      "title": "知识与问题数量不同",
      "description": "同一知识条目可能用于多个问题，不能据此推算引用次数。"
    },
    {
      "title": "回答表现不等于成交",
      "description": "项目未建立申请、审批或放款的归因链路。"
    }
  ],
  "strategyDescription": "围绕产品事实整理、审核与回答测试推进。",
  "strategies": [
    {
      "step": "策略一",
      "title": "限定问题范围",
      "description": "按六类需求及银行品牌、具体产品组织 50 个主要问题。",
      "items": [
        "观察全国性需求，不扩展地域问题或无限长尾词",
        "比较问法用于监测，自有内容聚焦本机构事实"
      ]
    },
    {
      "step": "策略二",
      "title": "审核并持续修正知识条目",
      "description": "每阶段进行 3 轮修正。",
      "items": [
        "核实费用、额度、材料与审核条件",
        "整理、审核、测试、修正后复核，随产品变化更新"
      ]
    },
    {
      "step": "策略三",
      "title": "记录阶段表现并完成交接",
      "description": "结合自有与第三方监测工具对照观察。",
      "items": [
        "分别记录出现回答率、知识条目和问题范围",
        "2026 年 8 月底转交银行内部维护"
      ]
    }
  ],
  "resultsTitle": "三个阶段的项目记录",
  "resultHeaders": [
    "记录项",
    "第 1 阶段",
    "第 2 阶段",
    "第 3 阶段"
  ],
  "results": [
    {
      "dimension": "实际起止时间",
      "before": "2025.11—2026.01",
      "after": "2026.02—2026.05",
      "change": "2026.06—2026.08"
    },
    {
      "dimension": "出现回答率",
      "before": "60%",
      "after": "85%",
      "change": "80%"
    },
    {
      "dimension": "知识条目收录数量",
      "before": "20 条",
      "after": "100 条",
      "change": "200 条"
    },
    {
      "dimension": "修正轮次",
      "before": "3 轮",
      "after": "3 轮",
      "change": "3 轮"
    }
  ],
  "businessOutcomes": [
    "阶段数据保留项目方的“出现回答率”名称，不改写成品牌推荐率或获客率。",
    "项目交付后，由银行按内部制度维护知识内容与审核流程。"
  ],
  "takeaways": [
    "以官方事实作为内容基础，保持不同信源一致。",
    "分别记录问题、知识条目和回答表现。",
    "监测结果与业务转化分开评估，保留实际阶段起止时间。"
  ],
  "disclaimer": "根据来源页面整理，数据由项目方提供且已脱敏，未附原始记录及完整采样口径。原文样本数表格与说明存在不一致，本页不引用该项。出现回答率不代表贷款申请、审批或放款转化；配图为概念示意。",
  "images": {
    "hero": {
      "src": "/case-details/bank-geo/00-hero.jpg",
      "alt": "匿名银行 GEO 案例原始封面",
      "caption": "原案例概念配图，非实际合作银行或产品界面；数据已脱敏。"
    },
    "overview": {
      "src": "/case-details/bank-geo/01-products.jpg",
      "alt": "六类金融产品需求示意",
      "caption": "原案例概念配图，非实际合作银行或产品界面；数据已脱敏。"
    },
    "channels": {
      "src": "/case-details/bank-geo/02-questions.jpg",
      "alt": "类目、品牌及产品问题范围示意",
      "caption": "原案例概念配图，非实际合作银行或产品界面；数据已脱敏。"
    },
    "strategy": {
      "src": "/case-details/bank-geo/03-knowledge.jpg",
      "alt": "知识条目审核和修正阶段示意",
      "caption": "原案例概念配图，非实际合作银行或产品界面；数据已脱敏。"
    },
    "results": {
      "src": "/case-details/bank-geo/04-results.jpg",
      "alt": "三个阶段出现回答率示意",
      "caption": "原案例概念配图，非实际合作银行或产品界面；数据已脱敏。"
    },
    "takeaways": {
      "src": "/case-details/bank-geo/05-handover.jpg",
      "alt": "2026 年 8 月底交付银行内部运营示意",
      "caption": "原案例概念配图，非实际合作银行或产品界面；数据已脱敏。"
    }
  }
} satisfies CaseStudyContent;
